import { render, staticRenderFns } from "./PieVis.vue?vue&type=template&id=5918ead0&scoped=true&"
import script from "./PieVis.vue?vue&type=script&lang=js&"
export * from "./PieVis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5918ead0",
  null
  
)

export default component.exports